var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-table',[_c('tbody',_vm._l((_vm.processedItems),function(items,id1){return _c('tr',[_vm._l((items),function(item){return [_c('td',[_c('v-subheader',[_vm._v(_vm._s(item.n))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.v))])]})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac89daa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/varticle/VParagraphTable.vue
// module id = null
// module chunks = 